import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getUserWallet = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet`
  );
};

export const getPersonWalletBalance = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet_balance`
  );
};

export const getPersonWalletBalanceByPersonId = (personId) => {
  return http.get(
    `${getBaseUrl()}/person_wallet_balance/${personId}`
  );
};


export const getPayment = id => {
  return http.get(
    `${getBaseUrl()}/payment/${id}`
  );
};

export const bankPayment = (data) => {
  return http.post(
    `${getBaseUrl()}/bank_payment`,
    data
  );
};

export const getBankPaymentResult = (id) => {
  return http.get(
    `${getBaseUrl()}/payment_result/${id}`
  );
};

